module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAmCAYAAACCjRgBAAABL0lEQVRYhe2YXRKDIAyEN50ezKN5NG8WnzITKfITkqoj31OxA+waAhFgci3U24GZ2wcnYmYm3VbjVOcmqsv7NKvphIh427aDaABY19V1nhADIh4AciY8cTegxS/LAiDWhKuBVDwzH0xE4JbEOfHqP6RRuVUSl8QDCI3EsIGaeCE14ZUTQwZaxQsRJswGesUL3ibMSZycqv0TqwQ9S+jQJJZJLeJ1v5bdqERYKfEvvhGD5kJvjVSNEAPAcb+XpI3g8UtoGriaxxsYqkY9SoHSOdBykA3tQqOHkAePX0LvM5Bb95Ef7TXeF4G7EVXM/dzApc+kPXJzBxgNlNZ87jpRfTtQ+kx+n1xDVk2YDKRvxyuJLeOEldMWMi+m2ue2SdwaDfcI6ASVtrVfSwQmk7ezA5nu180WvHx1AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/IEHOME.png
// module id = 70
// module chunks = 0